import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b7c8b56"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "element-loading-background": "rgba(0, 0, 0, 0.5)",
  style: {"padding-top":"0px"}
}
const _hoisted_2 = {
  key: 0,
  style: {"font-weight":"400","color":"red"}
}
const _hoisted_3 = {
  key: 1,
  class: "summary-time"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"900"} }, "提单号码：", -1))
const _hoisted_5 = { style: {"margin-left":"20px"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"900"} }, "ETD：", -1))
const _hoisted_7 = { style: {"margin-left":"20px"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"900"} }, "ATD：", -1))
const _hoisted_9 = { style: {"margin-left":"20px"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"900"} }, "ETA：", -1))
const _hoisted_11 = { style: {"margin-left":"20px"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"900"} }, "ATA：", -1))
const _hoisted_13 = { style: {"font-size":"14px","font-weight":"900","margin-top":"-5px"} }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 2,
  title: "订单已锁定",
  style: {"padding-left":"5px"}
}
const _hoisted_16 = { style: {"margin-left":"20px"} }
const _hoisted_17 = {
  key: 4,
  style: {"margin-left":"10px"}
}
const _hoisted_18 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"5px"} }, "已分摊", -1))
const _hoisted_24 = {
  key: 3,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden"}
}
const _hoisted_25 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"48px"}
}
const _hoisted_26 = { class: "link" }
const _hoisted_27 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_28 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"48px"}
}
const _hoisted_29 = { class: "link" }
const _hoisted_30 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_31 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_32 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_33 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"48px"}
}
const _hoisted_34 = { class: "link" }
const _hoisted_35 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"46px","line-height":"40px"}
}
const _hoisted_39 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"40px","line-height":"40px"}
}
const _hoisted_40 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_41 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"46px"}
}
const _hoisted_45 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_46 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"46px"}
}
const _hoisted_47 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_48 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"46px"}
}
const _hoisted_49 = { key: 1 }
const _hoisted_50 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_51 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"46px"}
}
const _hoisted_55 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_56 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"46px"}
}
const _hoisted_57 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_58 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"46px"}
}
const _hoisted_59 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_60 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"46px"}
}
const _hoisted_61 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_62 = { style: {"margin":"0px"} }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "记账起始时间", -1))
const _hoisted_64 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"46px"}
}
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { style: {"margin":"0px"} }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "账期（天数）", -1))
const _hoisted_68 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"46px"}
}
const _hoisted_69 = { class: "link" }
const _hoisted_70 = { key: 1 }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = {
  key: 0,
  style: {"font-size":"13px","color":"#fe995b","font-weight":"900","padding-top":"15px","z-index":"-1"}
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 批量添加 ", -1))
const _hoisted_74 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_76 = { style: {"clear":"both"} }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 批量添加 ", -1))
const _hoisted_78 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_80 = { style: {"clear":"both"} }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "添加")
], -1))
const _hoisted_82 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_83 = { style: {"clear":"both","margin-top":"20px"} }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "导入")
], -1))
const _hoisted_85 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { class: "link" }
const _hoisted_88 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_89 = { key: 1 }
const _hoisted_90 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_91 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_92 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","cursor":"pointer"}
}
const _hoisted_93 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_94 = { key: 1 }
const _hoisted_95 = ["onClick"]
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"5px"} }, "已分摊", -1))
const _hoisted_97 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_98 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_99 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_100 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_101 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_102 = ["title"]
const _hoisted_103 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left"}
}
const _hoisted_104 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px"}
}
const _hoisted_105 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_106 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_107 = { key: 0 }
const _hoisted_108 = { key: 1 }
const _hoisted_109 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_110 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_111 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_112 = { key: 0 }
const _hoisted_113 = { key: 1 }
const _hoisted_114 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_115 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_116 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_117 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_118 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px"}
}
const _hoisted_119 = { key: 1 }
const _hoisted_120 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px"}
}
const _hoisted_121 = { key: 1 }
const _hoisted_122 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_123 = { key: 1 }
const _hoisted_124 = ["onClick"]
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"5px"} }, "已分摊", -1))
const _hoisted_126 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_127 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_128 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_129 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_130 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_131 = ["title"]
const _hoisted_132 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left"}
}
const _hoisted_133 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px"}
}
const _hoisted_134 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_135 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_136 = { key: 0 }
const _hoisted_137 = { key: 1 }
const _hoisted_138 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_139 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_140 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_141 = { key: 0 }
const _hoisted_142 = { key: 1 }
const _hoisted_143 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_144 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_145 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_146 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_147 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px"}
}
const _hoisted_148 = { key: 1 }
const _hoisted_149 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px"}
}
const _hoisted_150 = { key: 1 }
const _hoisted_151 = { key: 1 }
const _hoisted_152 = { class: "link" }
const _hoisted_153 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_154 = { key: 1 }
const _hoisted_155 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_156 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_157 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","cursor":"pointer"}
}
const _hoisted_158 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_159 = { key: 1 }
const _hoisted_160 = ["onClick"]
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"5px"} }, "已分摊", -1))
const _hoisted_162 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_163 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_164 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_165 = ["title"]
const _hoisted_166 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left"}
}
const _hoisted_167 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px"}
}
const _hoisted_168 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_169 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_170 = { key: 0 }
const _hoisted_171 = { key: 1 }
const _hoisted_172 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_173 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_174 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_175 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_176 = { key: 0 }
const _hoisted_177 = { key: 1 }
const _hoisted_178 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_179 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_180 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_181 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_182 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_183 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_184 = { key: 2 }
const _hoisted_185 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_186 = { key: 1 }
const _hoisted_187 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_188 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_189 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","cursor":"pointer"}
}
const _hoisted_190 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_191 = { key: 1 }
const _hoisted_192 = ["onClick"]
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"5px"} }, "已分摊", -1))
const _hoisted_194 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_195 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_196 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_197 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_198 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_199 = ["title"]
const _hoisted_200 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left"}
}
const _hoisted_201 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px"}
}
const _hoisted_202 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_203 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_204 = { key: 0 }
const _hoisted_205 = { key: 1 }
const _hoisted_206 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_207 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_208 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_209 = { key: 0 }
const _hoisted_210 = { key: 1 }
const _hoisted_211 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_212 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_213 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_214 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_215 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px"}
}
const _hoisted_216 = { key: 1 }
const _hoisted_217 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px"}
}
const _hoisted_218 = { key: 1 }
const _hoisted_219 = { style: {"clear":"both","margin-top":"20px"} }
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, "提示", -1))
const _hoisted_221 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_222 = { key: 0 }
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100% !important","text-align":"center","font-size":"16px","font-weight":"900"} }, " 保存后账单信息将发送至客户企业，是否继续？ ", -1))
const _hoisted_224 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 添加 ", -1))
const _hoisted_226 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_227 = {
  key: 0,
  style: {"color":"red","margin":"0px 0px 20px 20px"}
}
const _hoisted_228 = { key: 0 }
const _hoisted_229 = ["title"]
const _hoisted_230 = { style: {"clear":"both"} }
const _hoisted_231 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 添加 ", -1))
const _hoisted_232 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_233 = { class: "link" }
const _hoisted_234 = { style: {"clear":"both"} }
const _hoisted_235 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 账期 ", -1))
const _hoisted_236 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_237 = { style: {"clear":"both"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_menu_tab = _resolveComponent("miezz-menu-tab")!
  const _component_Lock = _resolveComponent("Lock")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Check = _resolveComponent("Check")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_Minus = _resolveComponent("Minus")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_miezz_currency = _resolveComponent("miezz-currency")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Rank = _resolveComponent("Rank")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_supplier = _resolveComponent("miezz-supplier")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_miezz_menu_tab, {
      modelValue: _ctx.menuTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menuTab) = $event))
    }, {
      center: _withCtx(() => [
        (_ctx.dto.PoolStatus == 40)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 取消状态下的账单信息，删除费用信息暂存可关闭相应待办任务 "))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", null, [
                _hoisted_4,
                _createTextVNode(_toDisplayString(_ctx.dtoDetailTime.BLNO), 1)
              ]),
              _createElementVNode("span", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(_toDisplayString(_ctx.dtoDetailTime.ETD), 1)
              ]),
              _createElementVNode("span", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(_toDisplayString(_ctx.dtoDetailTime.ATD), 1)
              ]),
              _createElementVNode("span", _hoisted_9, [
                _hoisted_10,
                _createTextVNode(_toDisplayString(_ctx.dtoDetailTime.ETA), 1)
              ]),
              _createElementVNode("span", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(_toDisplayString(_ctx.dtoDetailTime.ATA), 1)
              ])
            ]))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_card, {
      style: _normalizeStyle(_ctx.billType == 10 ? 'background-color: #fff0f5;' : _ctx.billType == 20 ? 'background-color: #e2f1f8;' : '')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          (_ctx.dto.Code != null && _ctx.dto.Code != undefined && _ctx.dto.Code != '')
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOrder())),
                style: {"color":"#fe995b","cursor":"pointer"}
              }, "订单编号：" + _toDisplayString(_ctx.isString(_ctx.dto.Code)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_14, "订单编号：" + _toDisplayString(_ctx.isString(_ctx.dto.Code)), 1)),
          (_ctx.dto.IsLock == true)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Lock)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.dto.Total), 1),
          (_ctx.billType != 30 && _ctx.CustomerManagement_Company_CreditAndAccountingPeriod == true)
            ? (_openBlock(), _createElementBlock("span", {
                key: 3,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onAccount())),
                style: {"margin-left":"20px","color":"#fe995b","cursor":"pointer"}
              }, "账期信息"))
            : _createCommentVNode("", true),
          (_ctx.billType == 10)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                (_ctx.dto.IsDepartureChargeWeight == true)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      size: "small",
                      type: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDepartureChargeWeight()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("入库计费重量/体积")
                      ]),
                      _: 1
                    }))
                  : (_ctx.dto.IsDestinationChargeWeight == true)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        size: "small",
                        type: "primary",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onDestinationChargeWeight()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("入库计费重量/体积")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_form, {
          ref: "$billRuleForm",
          model: _ctx.dto,
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              onSelectionChange: _ctx.handleSelectionChangeBill,
              script: "",
              border: "",
              "tree-props": { children: 'Child', hasChildren: 'hasChildren' },
              "row-key": "Id",
              "default-expand-all": false,
              "row-class-name": _ctx.tableRowClassName,
              data: _ctx.dto.Items,
              ref: "$billTable",
              style: {"width":"100%","margin-top":"15px"},
              "header-cell-style": { 'text-align': 'left' },
              "cell-style": { 'text-align': 'left' }
            }, {
              default: _withCtx(() => [
                (_ctx.dto.IsOrderLock != true && _ctx.dto.IsPoolLock != true && _ctx.billType != 30)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      type: "selection",
                      width: "55",
                      selectable: _ctx.selectableBill
                    }, null, 8, ["selectable"]))
                  : _createCommentVNode("", true),
                (_ctx.dto.IsOrderLock != true && _ctx.dto.IsPoolLock != true && _ctx.billType != 30)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 1,
                      width: "30"
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.IsSave == true)
                          ? (_openBlock(), _createBlock(_component_el_icon, {
                              key: 0,
                              style: {"color":"forestgreen"},
                              title: "账单已提交"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Check)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.Pool",
                  label: "Booking No",
                  width: "150px",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.Pool)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.isString(scope.row.Pool.BookingNo, scope.row)), 1))
                      : (scope.row.Child == null || scope.row.Child == undefined || scope.row.Child.length <= 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                            (_ctx.billType == 20)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "未分摊"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_21, "—"))
                          ]))
                        : (_ctx.billType == 20)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 2,
                              style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","color":"#fe995b","cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.onChild(scope.row))
                            }, [
                              (scope.row.IsOpen == false)
                                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Plus)
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Minus)
                                    ]),
                                    _: 1
                                  })),
                              _hoisted_23
                            ], 8, _hoisted_22))
                          : (_openBlock(), _createElementBlock("span", _hoisted_24, " — "))
                  ]),
                  _: 1
                }),
                (_ctx.billType == 10)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 2,
                      prop: "scope.row.ClientCompanyId",
                      label: "对账对象",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.FromId == null || scope.row.FromId == undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                rules: _ctx.rules.PreClientLabel,
                                prop: 'Items.' + scope.row.Index + '.PreClientLabel'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_autocomplete, {
                                    modelValue: scope.row.PreClientLabel,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.PreClientLabel) = $event),
                                    clearable: true,
                                    disabled: (scope.row.IsSettlement == true || scope.row.IsSave == true || scope.row.IsInvoice) ? true : false,
                                    "fetch-suggestions": _ctx.querySearchClientCompany,
                                    "popper-class": "my-autocomplete",
                                    placeholder: "请填写关键词",
                                    onChange: ($event: any) => (_ctx.onChangeClientCompanyId(scope.row.Index)),
                                    onClear: ($event: any) => (_ctx.onChangeClientCompanyId(scope.row.Index)),
                                    onSelect: ((item) => { _ctx.handleSelectClientCompany(item, scope.row.Index) })
                                  }, {
                                    default: _withCtx(({ item }) => [
                                      _createElementVNode("span", _hoisted_26, _toDisplayString(item.Label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "fetch-suggestions", "onChange", "onClear", "onSelect"])
                                ]),
                                _: 2
                              }, 1032, ["rules", "prop"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_27, "—"))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.billType == 20)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 3,
                      prop: "scope.row.PreSupplierLabel",
                      label: "对账对象",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.FromId == null || scope.row.FromId == undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                rules: _ctx.rules.PreSupplierLabel,
                                prop: 'Items.' + scope.row.Index + '.PreSupplierLabel'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_autocomplete, {
                                    modelValue: scope.row.PreSupplierLabel,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.PreSupplierLabel) = $event),
                                    clearable: true,
                                    disabled: (scope.row.IsSettlement == true || scope.row.IsSave == true || scope.row.IsInvoice == true) ? true : false,
                                    "fetch-suggestions": _ctx.querySearchSupplierCompany,
                                    "popper-class": "my-autocomplete",
                                    placeholder: "请填写关键词",
                                    onChange: ($event: any) => (_ctx.onChangeSupplierCompanyId(scope.row.Index)),
                                    onClear: ($event: any) => (_ctx.onChangeSupplierCompanyId(scope.row.Index)),
                                    onSelect: ((item) => { _ctx.handleSelectSupplierCompany(item, scope.row.Index) })
                                  }, {
                                    default: _withCtx(({ item }) => [
                                      _createElementVNode("span", _hoisted_29, _toDisplayString(item.Label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "fetch-suggestions", "onChange", "onClear", "onSelect"])
                                ]),
                                _: 2
                              }, 1032, ["rules", "prop"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.isString(scope.row.SupplierLabel)), 1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.billType == 30)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 4,
                      prop: "scope.row.SalerNameLabel",
                      width: "120px",
                      label: "业务员",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.FromId == null || scope.row.FromId == undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.isString(scope.row.SalerNameLabel)), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_32, "—"))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.CostId",
                  label: "费用名称",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.FromId == null || scope.row.FromId == undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createVNode(_component_el_form_item, {
                            "label-width": "0px",
                            label: "",
                            rules: _ctx.isCheck == true ? _ctx.rules.CostId : '',
                            prop: 'Items.' + scope.row.Index + '.CostId'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_autocomplete, {
                                modelValue: scope.row.CostName,
                                "onUpdate:modelValue": ($event: any) => ((scope.row.CostName) = $event),
                                clearable: true,
                                disabled: (scope.row.IsSave == true) ? true : false,
                                "fetch-suggestions": _ctx.querySearchCost,
                                "popper-class": "my-autocomplete",
                                placeholder: "请填写关键词",
                                onChange: ($event: any) => (_ctx.onChangeCostId(scope.row.Index)),
                                onClear: ($event: any) => (_ctx.onChangeCostId(scope.row.Index)),
                                onSelect: ((item) => { _ctx.handleSelectCost(item, scope.row.Index) })
                              }, {
                                default: _withCtx(({ item }) => [
                                  _createElementVNode("span", _hoisted_34, _toDisplayString(item.Label), 1)
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "fetch-suggestions", "onChange", "onClear", "onSelect"])
                            ]),
                            _: 2
                          }, 1032, ["rules", "prop"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          (scope.row.Cost != null && scope.row.Cost != undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.isString(scope.row.Cost.NameZh, scope.row)) + "分摊", 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_37, "暂无数据"))
                        ]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.CurrencySystem",
                  label: "币制",
                  width: "110px",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.FromId == null || scope.row.FromId == undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createVNode(_component_el_form_item, {
                            "label-width": "0px",
                            label: "",
                            prop: 'Items.' + scope.row.Index + '.CurrencySystemId',
                            rules: _ctx.isCheck == true ? [
                                        {
                                            required: true,
                                            message: '信息不能为空',
                                            trigger: 'change',
                                        },
                                    ] : ''
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                "no-data-text": '无匹配信息',
                                "no-match-text": '无匹配信息',
                                onChange: ($event: any) => (_ctx.onChangeCurrencySystem(scope.row.Index)),
                                disabled: (scope.row.IsSettlement == true || scope.row.IsSave == true || scope.row.IsInvoice == true) ? true : false,
                                modelValue: scope.row.CurrencySystemId,
                                "onUpdate:modelValue": ($event: any) => ((scope.row.CurrencySystemId) = $event),
                                filterable: "",
                                placeholder: "请选择"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencyList, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.Value,
                                      label: item.Label,
                                      value: item.Value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["onChange", "disabled", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["prop", "rules"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          (scope.row.CurrencySystem)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code, scope.row)), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                (scope.row.FromId != undefined)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, "—"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_43, "暂无数据"))
                              ]))
                        ]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.UnitPrice",
                  label: "单价",
                  width: "100px",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.FromId == null || scope.row.FromId == undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createVNode(_component_el_form_item, {
                            "label-width": "0px",
                            label: "",
                            prop: 'Items.' + scope.row.Index + '.UnitPrice',
                            rules: _ctx.isCheck == true ? [
                                        {
                                            required: true,
                                            message: '信息不能为空',
                                            trigger: 'blur',
                                        },
                                    ] : ''
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                placeholder: "请填写",
                                disabled: (scope.row.IsSettlement == true || scope.row.IsSave == true || scope.row.IsInvoice == true) ? true : false,
                                onChange: ($event: any) => (_ctx.onChangeUnitPrice(scope.row.Index)),
                                number: true,
                                pattern: "[-0-9.,]",
                                modelValue: scope.row.UnitPrice,
                                "onUpdate:modelValue": ($event: any) => ((scope.row.UnitPrice) = $event)
                              }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["prop", "rules"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.isString(scope.row.UnitPrice, scope.row)), 1))
                  ]),
                  _: 1
                }),
                (_ctx.currencySystem?.ShowTaxRate && _ctx.billType != 30)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 5,
                      prop: "scope.row.TaxRate",
                      label: "税率%",
                      width: "100px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.FromId == null || scope.row.FromId == undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                prop: 'Items.' + scope.row.Index + '.TaxRate'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    placeholder: "请填写",
                                    disabled: (scope.row.IsSettlement == true || scope.row.IsSave == true || scope.row.IsInvoice == true) ? true : false,
                                    onChange: ($event: any) => (_ctx.onSum(scope.$index)),
                                    number: true,
                                    pattern: "[0-9.]",
                                    modelValue: scope.row.TaxRate,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.TaxRate) = $event)
                                  }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["prop"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_ctx.isString(scope.row.TaxRate, scope.row)), 1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.FirstChargeUnitId",
                  label: "计价单位",
                  width: "120px",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.FromId == null || scope.row.FromId == undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _createVNode(_component_el_form_item, {
                            "label-width": "0px",
                            label: "",
                            prop: 'Items.' + scope.row.Index + '.FirstChargeUnitId',
                            rules: _ctx.isCheck == true ? [
                                        {
                                            required: true,
                                            message: '信息不能为空',
                                            trigger: 'change',
                                        },
                                    ] : ''
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                "no-data-text": '无匹配信息',
                                "no-match-text": '无匹配信息',
                                disabled: (scope.row.IsSettlement == true || scope.row.IsSave == true || scope.row.IsInvoice == true) ? true : false,
                                modelValue: scope.row.FirstChargeUnitId,
                                "onUpdate:modelValue": ($event: any) => ((scope.row.FirstChargeUnitId) = $event),
                                filterable: "",
                                placeholder: "请选择",
                                onChange: ($event: any) => (_ctx.onChangeFirstChargeUnitNumber(scope.row.Index))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chargeUnits, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.Value,
                                      label: item.Label,
                                      value: item.Value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            _: 2
                          }, 1032, ["prop", "rules"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          (scope.row.FirstChargeUnit != null && scope.row.FirstChargeUnit != undefined)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnit.Code, scope.row)), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                (scope.row.FromId != undefined)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, "—"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_53, "暂无数据"))
                              ]))
                        ]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.FirstChargeUnitNumber",
                  label: "数量",
                  width: "120px",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.FromId == null || scope.row.FromId == undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createVNode(_component_el_form_item, {
                            "label-width": "0px",
                            label: "",
                            prop: 'Items.' + scope.row.Index + '.FirstChargeUnitNumber',
                            rules: _ctx.isCheck == true ? [
                                        {
                                            required: true,
                                            message: '信息不能为空',
                                            trigger: 'blur',
                                        },
                                    ] : ''
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: scope.row.FirstChargeUnitNumber,
                                "onUpdate:modelValue": ($event: any) => ((scope.row.FirstChargeUnitNumber) = $event),
                                disabled: (scope.row.IsSettlement == true || scope.row.IsSave == true || scope.row.IsInvoice == true) ? true : false,
                                placeholder: "请填写",
                                onChange: ($event: any) => (_ctx.onChangeFirstChargeUnitNumber(scope.row.Index)),
                                class: "input-with-select"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                            ]),
                            _: 2
                          }, 1032, ["prop", "rules"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnitNumber, scope.row)), 1))
                  ]),
                  _: 1
                }),
                (_ctx.currencySystem?.ShowTaxRate && _ctx.billType != 30)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 6,
                      prop: "scope.row.TaxAmount",
                      label: "税额",
                      width: "120px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.FromId == null || scope.row.FromId == undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                prop: 'Items.' + scope.row.Index + '.TaxAmount',
                                rules: _ctx.isCheck == true ? [
                                        {
                                            required: true,
                                            message: '信息不能为空',
                                            trigger: 'blur',
                                        },
                                    ] : ''
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    modelValue: scope.row.TaxAmount,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.TaxAmount) = $event),
                                    disabled: (scope.row.IsSettlement == true || scope.row.IsSave == true || scope.row.IsInvoice == true) ? true : false,
                                    placeholder: "请填写",
                                    onChange: ($event: any) => (_ctx.onSumByTaxAmount(scope.row.Index)),
                                    number: true,
                                    pattern: "[-0-9.,]",
                                    class: _normalizeClass('input-with-select ' + ((parseFloat((scope?.row?.UnitPrice ?? 0) * (scope?.row?.FirstChargeUnitNumber ?? 0) * (scope?.row?.TaxRate ?? 0) / 100).toFixed(2) != parseFloat(scope?.row?.TaxAmount ?? 0).toFixed(2)) ? 'red' : ''))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange", "class"])
                                ]),
                                _: 2
                              }, 1032, ["prop", "rules"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_ctx.isString(scope.row.TaxAmount, scope.row)), 1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.TotalPrice",
                  label: "单项合计",
                  width: "120px",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.FromId == null || scope.row.FromId == undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _createVNode(_component_el_form_item, {
                            "label-width": "0px",
                            label: "",
                            prop: 'Items.' + scope.row.Index + '.TotalPrice',
                            rules: _ctx.isCheck == true ? [
                                        {
                                            required: true,
                                            message: '信息不能为空',
                                            trigger: 'blur',
                                        },
                                    ] : ''
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: scope.row.TotalPrice,
                                "onUpdate:modelValue": ($event: any) => ((scope.row.TotalPrice) = $event),
                                disabled: (scope.row.IsSettlement == true || scope.row.IsSave == true || scope.row.IsInvoice == true) ? true : false,
                                placeholder: "请填写",
                                number: true,
                                pattern: "[-0-9.,]",
                                class: "input-with-select"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                            ]),
                            _: 2
                          }, 1032, ["prop", "rules"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.isString(scope.row.TotalPrice, scope.row)), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.Remark",
                  label: "备注",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.FromId == null || scope.row.FromId == undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                          _createVNode(_component_el_form_item, {
                            "label-width": "0px",
                            label: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: scope.row.Remark,
                                "onUpdate:modelValue": ($event: any) => ((scope.row.Remark) = $event),
                                onChange: ($event: any) => (_ctx.onChangeRemark(scope.row.Index)),
                                disabled: (scope.row.IsSave == true) ? true : false,
                                placeholder: "请填写"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.isString(scope.row.Remark, scope.row)), 1))
                  ]),
                  _: 1
                }),
                _createElementVNode("div", null, [
                  (_ctx.billType != 30)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        style: {"display":"none"},
                        prop: "scope.row.TotalPrice",
                        label: "记账起始时间",
                        width: "0px",
                        "show-overflow-tooltip": true
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_62, [
                            _hoisted_63,
                            (_ctx.isSave != true)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  style: {"cursor":"pointer","margin-left":"2px","color":"#00a5fb"},
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onStartDate()))
                                }, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Edit)
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        default: _withCtx((scope) => [
                          (scope.row.FromId == null || scope.row.FromId == undefined)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                _createVNode(_component_el_form_item, {
                                  "label-width": "0px",
                                  label: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_date_picker, {
                                      modelValue: scope.row.StartDate,
                                      "onUpdate:modelValue": ($event: any) => ((scope.row.StartDate) = $event),
                                      onChange: ($event: any) => (_ctx.onChangeStartDate(scope.row.Index)),
                                      disabled: (scope.row.IsSettlement == true || scope.row.IsSave == true || scope.row.IsInvoice == true) ? true : false,
                                      placeholder: "请选择",
                                      format: "YYYY/MM/DD"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_65, "—"))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.billType != 30)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 1,
                        style: {"display":"none"},
                        prop: "scope.row.AccountPeriod",
                        label: "账期（天数）",
                        width: "0px",
                        "show-overflow-tooltip": true
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_66, [
                            _hoisted_67,
                            (_ctx.isSave != true)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  style: {"cursor":"pointer","margin-left":"2px","color":"#00a5fb"},
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onAccountPeriod()))
                                }, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Edit)
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        default: _withCtx((scope) => [
                          (scope.row.FromId == null || scope.row.FromId == undefined)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                _createVNode(_component_el_form_item, {
                                  "label-width": "0px",
                                  label: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_autocomplete, {
                                      modelValue: scope.row.AccountPeriod,
                                      "onUpdate:modelValue": ($event: any) => ((scope.row.AccountPeriod) = $event),
                                      clearable: true,
                                      disabled: (scope.row.IsSettlement == true || scope.row.IsSave == true || scope.row.IsInvoice == true) ? true : (_ctx.billType == 20 && (scope.row.SupplierCompanyId == undefined || scope.row.SupplierCompanyId == null)) ? true : false,
                                      "fetch-suggestions": ((queryString, cb) => { _ctx.querySearchAccount(queryString, cb, scope.row.Index) }),
                                      "popper-class": "my-autocomplete",
                                      placeholder: "请填写关键词",
                                      onChange: ($event: any) => (_ctx.onChangeAccountPeriod(scope.row.Index)),
                                      onClear: ($event: any) => (_ctx.onChangeAccount(scope.row.Index)),
                                      onSelect: ((item) => { _ctx.handleSelectAccount(item, scope.row.Index) })
                                    }, {
                                      default: _withCtx(({ item }) => [
                                        _createElementVNode("span", _hoisted_69, _toDisplayString(item.Label), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "fetch-suggestions", "onChange", "onClear", "onSelect"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_70, "—"))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_table_column, {
                  prop: "Executor",
                  label: "操作",
                  width: "60"
                }, {
                  default: _withCtx((scope) => [
                    ((scope.row.ParentId == null || scope.row.ParentId == undefined) & (scope.row.FromId == null || scope.row.FromId == undefined))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.onDelete(scope.row.Index)),
                          style: {"width":"100% !important","overflow":"hidden","height":"46px","line-height":"40px","cursor":"pointer"}
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_71))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSelectionChange", "row-class-name", "data"]),
            (_ctx.dto.IsOrderLock != true && (_ctx.orderId != null && _ctx.orderId != undefined && _ctx.orderId != '' || _ctx.id != null && _ctx.id != undefined && _ctx.id != '' && _ctx.dto.IsPoolLock != true))
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  _createElementVNode("span", {
                    style: {"cursor":"pointer"},
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onAddBill && _ctx.onAddBill(...args)))
                  }, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" 添加")
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["style"]),
    _createVNode(_component_miezz_button_bar, {
      modelValue: _ctx.bottomButtons,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.bottomButtons) = $event)),
      isFix: true,
      right: '42%',
      onHandleClick: _ctx.handleClick
    }, null, 8, ["modelValue", "onHandleClick"]),
    _createVNode(_component_miezz_currency, {
      defaultRate: '美元',
      isRate: true,
      defaultCurrency: '美元',
      ref: "Currency",
      onOnSelectCurrency: _ctx.onSelectCurrency
    }, null, 8, ["onOnSelectCurrency"]),
    (_ctx.startDateRuleForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.startDateRuleForm.Visiable,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.startDateRuleForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_73,
            _createElementVNode("div", _hoisted_74, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref: "refTimeRuleForm",
              model: _ctx.startDateRuleForm
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "记账起始时间",
                  prop: "Time",
                  rules: [
                    {
                        required: true,
                        message: '信息不能为空',
                        trigger: 'change',
                    },
                ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.startDateRuleForm.Time,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.startDateRuleForm.Time) = $event)),
                      style: {"width":"100% !important"},
                      placeholder: "请选择"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _hoisted_75,
            _createElementVNode("div", _hoisted_76, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.startDateBottomButtons,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.startDateBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickStartDate
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.accountPeriodRuleForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.accountPeriodRuleForm.Visiable,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.accountPeriodRuleForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_77,
            _createElementVNode("div", _hoisted_78, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_form, {
                ref: "refAccountPeriodRuleForm",
                model: _ctx.accountPeriodRuleForm
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "账期（天数）",
                    prop: "AccountPeriod",
                    rules: [
                        {
                            required: true,
                            message: '信息不能为空',
                            trigger: 'change',
                        },
                    ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.accountPeriodRuleForm.AccountPeriod,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.accountPeriodRuleForm.AccountPeriod) = $event)),
                        onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onChangePeriod())),
                        placeholder: "请填写"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _hoisted_79,
            _createElementVNode("div", _hoisted_80, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.accountPeriodBottomButtons,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.accountPeriodBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickAccountPeriod
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.templateForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 2,
          modelValue: _ctx.templateForm.Visiable,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.templateForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_81,
            _createElementVNode("div", _hoisted_82, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_form, {
                model: _ctx.templateForm,
                ref: "$refTemplateForm",
                "label-width": "0px"
              }, {
                default: _withCtx(() => [
                  (_ctx.OrderManagement_Pool_Summary_BillingInformation_PublicTemplate == true || _ctx.OrderManagement_Order_Summary_BillingInformation_PublicTemplate == true)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        "label-width": "150px",
                        label: "是否公开"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.templateForm.IsOpen,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.templateForm.IsOpen) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    "label-width": "150px",
                    label: "模板名称",
                    prop: "Name",
                    rules: [
                        {
                            required: true,
                            message: '信息不能为空',
                            trigger: 'blur',
                        },
                    ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.templateForm.Name,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.templateForm.Name) = $event)),
                        placeholder: "请填写"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _createElementVNode("div", _hoisted_83, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.templateBottomButtons,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.templateBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickTemplate
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.importForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 3,
          modelValue: _ctx.importForm.Visiable,
          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.importForm.Visiable) = $event)),
          "show-close": false,
          style: _normalizeStyle('width:' + _ctx.importWidth + ';'),
          top: "0px",
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_84,
            _createElementVNode("div", _hoisted_85, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.billType == 10)
              ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                  _createVNode(_component_el_form, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        "label-width": "100px",
                        label: "委托人"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_autocomplete, {
                            modelValue: _ctx.selectBillObject.BillLabel,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selectBillObject.BillLabel) = $event)),
                            clearable: true,
                            "fetch-suggestions": _ctx.querySearchBillClientCompany,
                            "popper-class": "my-autocomplete",
                            placeholder: "请填写关键词",
                            onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onChangeBillClientCompanyId())),
                            onClear: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onChangeBillClientCompanyId())),
                            onSelect: _cache[23] || (_cache[23] = ((item) => { _ctx.handleSelectBillClientCompany(item) }))
                          }, {
                            default: _withCtx(({ item }) => [
                              _createElementVNode("span", _hoisted_87, _toDisplayString(item.Label), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "fetch-suggestions"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_tabs, {
                    modelValue: _ctx.activeName,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.activeName) = $event)),
                    type: "border-card",
                    onTabClick: _ctx.handleClickCollection
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tab_pane, {
                        label: "导入模板",
                        name: "0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_tabs, {
                            modelValue: _ctx.templateScopeTab,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.templateScopeTab) = $event)),
                            style: {"margin-top":"10px"},
                            onTabClick: _ctx.onTemplateScopeTabClick
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_tab_pane, {
                                label: "公开",
                                name: "open"
                              }),
                              _createVNode(_component_el_tab_pane, {
                                label: "我的",
                                name: "mine"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onTabClick"]),
                          _createVNode(_component_el_table, {
                            onSelectionChange: _ctx.handleSelectionChange,
                            "tree-props": { children: 'Child', hasChildren: 'hasChildren' },
                            "row-key": "TemplateId",
                            "default-expand-all": false,
                            data: _ctx.filteredTemplateItems,
                            ref: "$templateCollectionTable",
                            style: {"width":"100%","margin-top":"10px"},
                            "header-cell-style": { 'text-align': 'left' },
                            class: "import-template",
                            "cell-style": { 'text-align': 'left' },
                            border: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                type: "selection",
                                width: "55"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "Name",
                                label: "名称",
                                "show-overflow-tooltip": true
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("span", _hoisted_88, [
                                    ((_ctx.OrderManagement_Pool_Summary_BillingInformation_DeleteTemplate == true || _ctx.OrderManagement_Order_Summary_BillingInformation_DeleteTemplate == true) && (scope.row.IsOpen != true || (scope.row.IsOpen == true && (_ctx.OrderManagement_Pool_Summary_BillingInformation_PublicTemplate == true || _ctx.OrderManagement_Order_Summary_BillingInformation_PublicTemplate == true))))
                                      ? (_openBlock(), _createBlock(_component_el_input, {
                                          key: 0,
                                          modelValue: scope.row.Name,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.Name) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_89, _toDisplayString(_ctx.isString(scope.row.Name)), 1))
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "CreatedUserName",
                                label: "创建人",
                                "show-overflow-tooltip": true
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.isString(scope.row.CreatedUserName)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "IsOpen",
                                label: "公开",
                                "show-overflow-tooltip": true
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("span", _hoisted_91, _toDisplayString(scope.row.IsOpenData ? "是" : "否"), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "操作",
                                width: "90"
                              }, {
                                default: _withCtx((scope) => [
                                  ((_ctx.OrderManagement_Pool_Summary_BillingInformation_DeleteTemplate == true || _ctx.OrderManagement_Order_Summary_BillingInformation_DeleteTemplate == true) && (scope.row.IsOpen != true || (scope.row.IsOpen == true && (_ctx.OrderManagement_Pool_Summary_BillingInformation_PublicTemplate == true || _ctx.OrderManagement_Order_Summary_BillingInformation_PublicTemplate == true))))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                        _createVNode(_component_el_icon, {
                                          class: "drag-sort",
                                          title: "拖曳排序"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Rank)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_icon, {
                                          onClick: ($event: any) => (_ctx.onSaveTemplate(scope.$index)),
                                          title: "点击保存"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Check)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_el_icon, {
                                          onClick: ($event: any) => (_ctx.onDeleteTemplate(scope.$index)),
                                          title: "点击删除",
                                          style: {"margin-left":"5px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Delete)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onSelectionChange", "data"])
                        ]),
                        _: 1
                      }),
                      (_ctx.OrderManagement_Order_Summary_BillingInformation_ViewAccountsPayable == true)
                        ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                            key: 0,
                            label: "从应付账单导入",
                            name: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table, {
                                onSelectionChange: _ctx.handleSelectionChange,
                                "tree-props": { children: 'Child', hasChildren: 'hasChildren' },
                                "row-key": "Id",
                                "default-expand-all": false,
                                data: _ctx.paymentBill.Items,
                                ref: "$templateCollectionTableFromPayment",
                                style: {"width":"100%","margin-top":"15px"},
                                "header-cell-style": { 'text-align': 'left' },
                                "cell-style": { 'text-align': 'left' },
                                border: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, {
                                    type: "selection",
                                    width: "55",
                                    selectable: _ctx.selectablePayment
                                  }, null, 8, ["selectable"]),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.Pool",
                                    label: "Booking No",
                                    width: "150px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.Pool)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_93, _toDisplayString(_ctx.isString(scope.row.Pool.BookingNo, scope.row)), 1))
                                        : (scope.row.Child == null || scope.row.Child == undefined || scope.row.Child.length <= 0)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_94, " 未分摊 "))
                                          : (_openBlock(), _createElementBlock("span", {
                                              key: 2,
                                              style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","color":"#fe995b","cursor":"pointer"},
                                              onClick: ($event: any) => (_ctx.onTemplateChild(scope.row))
                                            }, [
                                              (scope.row.IsOpen == false)
                                                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Plus)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Minus)
                                                    ]),
                                                    _: 1
                                                  })),
                                              _hoisted_96
                                            ], 8, _hoisted_95))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.SupplierLabel",
                                    label: "供应商",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.FromId == null || scope.row.FromId == undefined)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_97, _toDisplayString(_ctx.isString(scope.row.SupplierLabel)), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_98, "—"))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.CostId",
                                    label: "费用名称",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.FromId == null || scope.row.FromId == undefined)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_99, _toDisplayString(_ctx.isString(scope.row.CostName)), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_100, _toDisplayString(_ctx.isString(scope.row.Cost.NameZh, scope.row)) + "分摊 ", 1))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.CurrencySystem",
                                    label: "币制",
                                    width: "60px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.FromId == null || scope.row.FromId == undefined)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                            (scope.row.CurrencySystem)
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  style: {"width":"100%","word-break":"break-all","text-align":"left"},
                                                  title: scope.row.CurrencySystem.FullName
                                                }, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code)), 9, _hoisted_102))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_103, " 暂无数据 "))
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                            (scope.row.CurrencySystem)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_105, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code, scope.row)), 1))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                                  (scope.row.FromId != undefined)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_107, "—"))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_108, "暂无数据"))
                                                ]))
                                          ]))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.UnitPrice",
                                    label: "单价",
                                    width: "100px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createElementVNode("div", _hoisted_109, _toDisplayString(_ctx.isString(scope.row.UnitPrice, scope.row)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.FirstChargeUnitId",
                                    label: "计价单位",
                                    width: "120px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.FirstChargeUnit != null && scope.row.FirstChargeUnit != undefined)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_110, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnit.Code, scope.row)), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                            (scope.row.FromId != undefined)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_112, "—"))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_113, "暂无数据"))
                                          ]))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.FirstChargeUnitNumber",
                                    label: "数量",
                                    width: "120px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createElementVNode("div", _hoisted_114, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnitNumber, scope.row)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.TotalPrice",
                                    label: "单项合计",
                                    width: "120px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.FromId == null || scope.row.FromId == undefined)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_115, _toDisplayString(scope.row.TotalPrice), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_116, _toDisplayString(_ctx.isString(scope.row.TotalPrice, scope.row)), 1))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.Remark",
                                    label: "备注",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createElementVNode("div", _hoisted_117, _toDisplayString(_ctx.isString(scope.row.Remark, scope.row)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.billType != 30)
                                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                                        key: 0,
                                        prop: "scope.row.StartDateString",
                                        label: "记账起始时间",
                                        width: "140px",
                                        "show-overflow-tooltip": true
                                      }, {
                                        default: _withCtx((scope) => [
                                          (scope.row.FromId == null || scope.row.FromId == undefined)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_118, _toDisplayString(_ctx.isString(scope.row.StartDateString)), 1))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_119, "—"))
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.AccountPeriod",
                                    label: "账期（天数）",
                                    width: "130px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.FromId == null || scope.row.FromId == undefined)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_120, _toDisplayString(_ctx.isString(scope.row.AccountPeriod)), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_121, "—"))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onSelectionChange", "data"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.OrderManagement_Order_Summary_BillingInformation_ViewSettlementPrice == true)
                        ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                            key: 1,
                            label: "从结算账单导入",
                            name: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table, {
                                onSelectionChange: _ctx.handleSelectionChange,
                                "tree-props": { children: 'Child', hasChildren: 'hasChildren' },
                                "row-key": "Id",
                                "default-expand-all": false,
                                data: _ctx.paymentBill.Items,
                                ref: "$templateCollectionTableFromPayment",
                                style: {"width":"100%","margin-top":"15px"},
                                "header-cell-style": { 'text-align': 'left' },
                                "cell-style": { 'text-align': 'left' },
                                border: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, {
                                    type: "selection",
                                    width: "55",
                                    selectable: _ctx.selectablePayment
                                  }, null, 8, ["selectable"]),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.Pool",
                                    label: "Booking No",
                                    width: "150px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.Pool)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_122, _toDisplayString(_ctx.isString(scope.row.Pool.BookingNo, scope.row)), 1))
                                        : (scope.row.Child == null || scope.row.Child == undefined || scope.row.Child.length <= 0)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_123, " 未分摊 "))
                                          : (_openBlock(), _createElementBlock("span", {
                                              key: 2,
                                              style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","color":"#fe995b","cursor":"pointer"},
                                              onClick: ($event: any) => (_ctx.onTemplateChild(scope.row))
                                            }, [
                                              (scope.row.IsOpen == false)
                                                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Plus)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Minus)
                                                    ]),
                                                    _: 1
                                                  })),
                                              _hoisted_125
                                            ], 8, _hoisted_124))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.SupplierLabel",
                                    label: "供应商",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.FromId == null || scope.row.FromId == undefined)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_126, _toDisplayString(_ctx.isString(scope.row.SupplierLabel)), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_127, "—"))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.CostId",
                                    label: "费用名称",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.FromId == null || scope.row.FromId == undefined)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_128, _toDisplayString(_ctx.isString(scope.row.CostName)), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_129, _toDisplayString(_ctx.isString(scope.row.Cost.NameZh, scope.row)) + "分摊 ", 1))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.CurrencySystem",
                                    label: "币制",
                                    width: "60px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.FromId == null || scope.row.FromId == undefined)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                                            (scope.row.CurrencySystem)
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  style: {"width":"100%","word-break":"break-all","text-align":"left"},
                                                  title: scope.row.CurrencySystem.FullName
                                                }, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code)), 9, _hoisted_131))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_132, " 暂无数据 "))
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                            (scope.row.CurrencySystem)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_134, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code, scope.row)), 1))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_135, [
                                                  (scope.row.FromId != undefined)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_136, "—"))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_137, "暂无数据"))
                                                ]))
                                          ]))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.UnitPrice",
                                    label: "单价",
                                    width: "100px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createElementVNode("div", _hoisted_138, _toDisplayString(_ctx.isString(scope.row.UnitPrice, scope.row)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.FirstChargeUnitId",
                                    label: "计价单位",
                                    width: "120px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.FirstChargeUnit != null && scope.row.FirstChargeUnit != undefined)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_139, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnit.Code, scope.row)), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_140, [
                                            (scope.row.FromId != undefined)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_141, "—"))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_142, "暂无数据"))
                                          ]))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.FirstChargeUnitNumber",
                                    label: "数量",
                                    width: "120px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createElementVNode("div", _hoisted_143, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnitNumber, scope.row)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.TotalPrice",
                                    label: "单项合计",
                                    width: "120px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.FromId == null || scope.row.FromId == undefined)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_144, _toDisplayString(scope.row.TotalPrice), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_145, _toDisplayString(_ctx.isString(scope.row.TotalPrice, scope.row)), 1))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.Remark",
                                    label: "备注",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createElementVNode("div", _hoisted_146, _toDisplayString(_ctx.isString(scope.row.Remark, scope.row)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.billType != 30)
                                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                                        key: 0,
                                        prop: "scope.row.StartDateString",
                                        label: "记账起始时间",
                                        width: "140px",
                                        "show-overflow-tooltip": true
                                      }, {
                                        default: _withCtx((scope) => [
                                          (scope.row.FromId == null || scope.row.FromId == undefined)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_147, _toDisplayString(_ctx.isString(scope.row.StartDateString)), 1))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_148, "—"))
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_el_table_column, {
                                    prop: "scope.row.AccountPeriod",
                                    label: "账期（天数）",
                                    width: "130px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.FromId == null || scope.row.FromId == undefined)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_149, _toDisplayString(_ctx.isString(scope.row.AccountPeriod)), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_150, "—"))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onSelectionChange", "data"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onTabClick"])
                ]))
              : (_ctx.billType == 20)
                ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                    _createVNode(_component_el_form, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          "label-width": "100px",
                          label: "供应商"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_autocomplete, {
                              modelValue: _ctx.selectBillObject.BillLabel,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.selectBillObject.BillLabel) = $event)),
                              clearable: true,
                              "fetch-suggestions": _ctx.querySearchBillSupplierCompany,
                              "popper-class": "my-autocomplete",
                              placeholder: "请填写关键词",
                              onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onChangeBillSupplierCompanyId())),
                              onClear: _cache[28] || (_cache[28] = ($event: any) => (_ctx.onChangeBillSupplierCompanyId())),
                              onSelect: _cache[29] || (_cache[29] = ((item) => { _ctx.handleSelectBillSupplierCompany(item) }))
                            }, {
                              default: _withCtx(({ item }) => [
                                _createElementVNode("span", _hoisted_152, _toDisplayString(item.Label), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "fetch-suggestions"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tabs, {
                      modelValue: _ctx.activeName,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.activeName) = $event)),
                      type: "border-card",
                      onTabClick: _ctx.handleClickPayment
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: "导入模板",
                          name: "0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_tabs, {
                              modelValue: _ctx.templateScopeTab,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.templateScopeTab) = $event)),
                              style: {"margin-top":"10px"},
                              onTabClick: _ctx.onTemplateScopeTabClick
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_tab_pane, {
                                  label: "公开",
                                  name: "open"
                                }),
                                _createVNode(_component_el_tab_pane, {
                                  label: "我的",
                                  name: "mine"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onTabClick"]),
                            _createVNode(_component_el_table, {
                              onSelectionChange: _ctx.handleSelectionChange,
                              "tree-props": { children: 'Child', hasChildren: 'hasChildren' },
                              "row-key": "TemplateId",
                              "default-expand-all": false,
                              data: _ctx.filteredTemplateItems,
                              ref: "$templateCollectionTable",
                              style: {"width":"100%","margin-top":"10px"},
                              "header-cell-style": { 'text-align': 'left' },
                              class: "import-template",
                              "cell-style": { 'text-align': 'left' },
                              border: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_table_column, {
                                  type: "selection",
                                  width: "55"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "Name",
                                  label: "名称",
                                  "show-overflow-tooltip": true
                                }, {
                                  default: _withCtx((scope) => [
                                    _createElementVNode("span", _hoisted_153, [
                                      ((_ctx.OrderManagement_Pool_Summary_BillingInformation_DeleteTemplate == true || _ctx.OrderManagement_Order_Summary_BillingInformation_DeleteTemplate == true) && (scope.row.IsOpen != true || (scope.row.IsOpen == true && (_ctx.OrderManagement_Pool_Summary_BillingInformation_PublicTemplate == true || _ctx.OrderManagement_Order_Summary_BillingInformation_PublicTemplate == true))))
                                        ? (_openBlock(), _createBlock(_component_el_input, {
                                            key: 0,
                                            modelValue: scope.row.Name,
                                            "onUpdate:modelValue": ($event: any) => ((scope.row.Name) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_154, _toDisplayString(_ctx.isString(scope.row.Name)), 1))
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "CreatedUserName",
                                  label: "创建人",
                                  "show-overflow-tooltip": true
                                }, {
                                  default: _withCtx((scope) => [
                                    _createElementVNode("span", _hoisted_155, _toDisplayString(_ctx.isString(scope.row.CreatedUserName)), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "IsOpen",
                                  label: "公开",
                                  "show-overflow-tooltip": true
                                }, {
                                  default: _withCtx((scope) => [
                                    _createElementVNode("span", _hoisted_156, _toDisplayString(scope.row.IsOpenData ? "是" : "否"), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "操作",
                                  width: "90"
                                }, {
                                  default: _withCtx((scope) => [
                                    ((_ctx.OrderManagement_Pool_Summary_BillingInformation_DeleteTemplate == true || _ctx.OrderManagement_Order_Summary_BillingInformation_DeleteTemplate == true) && (scope.row.IsOpen != true || (scope.row.IsOpen == true && (_ctx.OrderManagement_Pool_Summary_BillingInformation_PublicTemplate == true || _ctx.OrderManagement_Order_Summary_BillingInformation_PublicTemplate == true))))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                          _createVNode(_component_el_icon, {
                                            class: "drag-sort",
                                            title: "拖曳排序"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Rank)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_icon, {
                                            onClick: ($event: any) => (_ctx.onSaveTemplate(scope.$index)),
                                            title: "点击保存"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Check)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          _createVNode(_component_el_icon, {
                                            onClick: ($event: any) => (_ctx.onDeleteTemplate(scope.$index)),
                                            title: "点击删除",
                                            style: {"margin-left":"5px"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Delete)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onSelectionChange", "data"])
                          ]),
                          _: 1
                        }),
                        (_ctx.orderId != undefined && _ctx.orderId != null && _ctx.orderId != '')
                          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                              key: 0,
                              label: "从舱务信息导入",
                              name: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_table, {
                                  onSelectionChange: _ctx.handleSelectionChange,
                                  "tree-props": { children: 'Child', hasChildren: 'hasChildren' },
                                  "row-key": "Id",
                                  "default-expand-all": false,
                                  data: _ctx.paymentBill.Items,
                                  ref: "$templateCollectionTableFromPayment",
                                  style: {"width":"100%","margin-top":"15px"},
                                  "header-cell-style": { 'text-align': 'left' },
                                  "cell-style": { 'text-align': 'left' },
                                  border: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_table_column, {
                                      type: "selection",
                                      width: "55",
                                      selectable: _ctx.selectablePayment
                                    }, null, 8, ["selectable"]),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.Pool",
                                      label: "Booking No",
                                      width: "150px",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        (scope.row.Pool)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_158, _toDisplayString(_ctx.isString(scope.row.Pool.BookingNo, scope.row)), 1))
                                          : (scope.row.Child == null || scope.row.Child == undefined || scope.row.Child.length <= 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_159, " 未分摊 "))
                                            : (_openBlock(), _createElementBlock("span", {
                                                key: 2,
                                                style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","color":"#fe995b","cursor":"pointer"},
                                                onClick: ($event: any) => (_ctx.onTemplateChild(scope.row))
                                              }, [
                                                (scope.row.IsOpen == false)
                                                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_Plus)
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_Minus)
                                                      ]),
                                                      _: 1
                                                    })),
                                                _hoisted_161
                                              ], 8, _hoisted_160))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.CostId",
                                      label: "费用名称",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        (scope.row.FromId == null || scope.row.FromId == undefined)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_162, _toDisplayString(_ctx.isString(scope.row.CostName)), 1))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_163, _toDisplayString(_ctx.isString(scope.row.Cost.NameZh, scope.row)) + "分摊 ", 1))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.CurrencySystem",
                                      label: "币制",
                                      width: "60px",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        (scope.row.FromId == null || scope.row.FromId == undefined)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                                              (scope.row.CurrencySystem)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    style: {"width":"100%","word-break":"break-all","text-align":"left"},
                                                    title: scope.row.CurrencySystem.FullName
                                                  }, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code)), 9, _hoisted_165))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_166, " 暂无数据 "))
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                              (scope.row.CurrencySystem)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_168, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code, scope.row)), 1))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_169, [
                                                    (scope.row.FromId != undefined)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_170, "—"))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_171, "暂无数据"))
                                                  ]))
                                            ]))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.UnitPrice",
                                      label: "单价",
                                      width: "100px",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("div", _hoisted_172, _toDisplayString(_ctx.isString(scope.row.UnitPrice, scope.row)), 1)
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.currencySystem?.ShowTaxRate)
                                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                                          key: 0,
                                          prop: "scope.row.TaxRate",
                                          label: "税率%",
                                          width: "100px",
                                          "show-overflow-tooltip": true
                                        }, {
                                          default: _withCtx((scope) => [
                                            _createElementVNode("div", _hoisted_173, _toDisplayString(_ctx.isString(scope.row.TaxRate, scope.row)), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.FirstChargeUnitId",
                                      label: "计价单位",
                                      width: "120px",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        (scope.row.FirstChargeUnit != null && scope.row.FirstChargeUnit != undefined)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_174, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnit.Code, scope.row)), 1))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_175, [
                                              (scope.row.FromId != undefined)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_176, "—"))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_177, "暂无数据"))
                                            ]))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.FirstChargeUnitNumber",
                                      label: "数量",
                                      width: "120px",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("div", _hoisted_178, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnitNumber, scope.row)), 1)
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.currencySystem?.ShowTaxRate)
                                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                                          key: 1,
                                          prop: "scope.row.TaxAmount",
                                          label: "税额",
                                          width: "120px",
                                          "show-overflow-tooltip": true
                                        }, {
                                          default: _withCtx((scope) => [
                                            (scope.row.FromId == null || scope.row.FromId == undefined)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_179, _toDisplayString(scope.row.TaxAmount), 1))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_180, _toDisplayString(_ctx.isString(scope.row.TaxAmount, scope.row)), 1))
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.TotalPrice",
                                      label: "单项合计",
                                      width: "120px",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        (scope.row.FromId == null || scope.row.FromId == undefined)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_181, _toDisplayString(scope.row.TotalPrice), 1))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_182, _toDisplayString(_ctx.isString(scope.row.TotalPrice, scope.row)), 1))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.Remark",
                                      label: "备注",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("div", _hoisted_183, _toDisplayString(_ctx.isString(scope.row.Remark, scope.row)), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onSelectionChange", "data"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onTabClick"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_184, [
                    _createVNode(_component_el_tabs, {
                      modelValue: _ctx.activeName,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.activeName) = $event)),
                      type: "border-card",
                      onTabClick: _ctx.handleClickSaler
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: "导入模板",
                          name: "0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_tabs, {
                              modelValue: _ctx.templateScopeTab,
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.templateScopeTab) = $event)),
                              style: {"margin-top":"10px"},
                              onTabClick: _ctx.onTemplateScopeTabClick
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_tab_pane, {
                                  label: "公开",
                                  name: "open"
                                }),
                                _createVNode(_component_el_tab_pane, {
                                  label: "我的",
                                  name: "mine"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onTabClick"]),
                            _createVNode(_component_el_table, {
                              onSelectionChange: _ctx.handleSelectionChange,
                              "tree-props": { children: 'Child', hasChildren: 'hasChildren' },
                              "row-key": "TemplateId",
                              "default-expand-all": false,
                              data: _ctx.filteredTemplateItems,
                              ref: "$templateCollectionTable",
                              style: {"width":"100%","margin-top":"10px"},
                              "header-cell-style": { 'text-align': 'left' },
                              class: "import-template",
                              "cell-style": { 'text-align': 'left' },
                              border: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_table_column, {
                                  type: "selection",
                                  width: "55"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "Name",
                                  label: "名称",
                                  "show-overflow-tooltip": true
                                }, {
                                  default: _withCtx((scope) => [
                                    _createElementVNode("span", _hoisted_185, [
                                      ((_ctx.OrderManagement_Pool_Summary_BillingInformation_DeleteTemplate == true || _ctx.OrderManagement_Order_Summary_BillingInformation_DeleteTemplate == true) && (scope.row.IsOpen != true || (scope.row.IsOpen == true && (_ctx.OrderManagement_Pool_Summary_BillingInformation_PublicTemplate == true || _ctx.OrderManagement_Order_Summary_BillingInformation_PublicTemplate == true))))
                                        ? (_openBlock(), _createBlock(_component_el_input, {
                                            key: 0,
                                            modelValue: scope.row.Name,
                                            "onUpdate:modelValue": ($event: any) => ((scope.row.Name) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_186, _toDisplayString(_ctx.isString(scope.row.Name)), 1))
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "CreatedUserName",
                                  label: "创建人",
                                  "show-overflow-tooltip": true
                                }, {
                                  default: _withCtx((scope) => [
                                    _createElementVNode("span", _hoisted_187, _toDisplayString(_ctx.isString(scope.row.CreatedUserName)), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "IsOpen",
                                  label: "公开",
                                  "show-overflow-tooltip": true
                                }, {
                                  default: _withCtx((scope) => [
                                    _createElementVNode("span", _hoisted_188, _toDisplayString(scope.row.IsOpenData ? "是" : "否"), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "操作",
                                  width: "90"
                                }, {
                                  default: _withCtx((scope) => [
                                    ((_ctx.OrderManagement_Pool_Summary_BillingInformation_DeleteTemplate == true || _ctx.OrderManagement_Order_Summary_BillingInformation_DeleteTemplate == true) && (scope.row.IsOpen != true || (scope.row.IsOpen == true && (_ctx.OrderManagement_Pool_Summary_BillingInformation_PublicTemplate == true || _ctx.OrderManagement_Order_Summary_BillingInformation_PublicTemplate == true))))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_189, [
                                          _createVNode(_component_el_icon, {
                                            class: "drag-sort",
                                            title: "拖曳排序"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Rank)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_icon, {
                                            onClick: ($event: any) => (_ctx.onSaveTemplate(scope.$index)),
                                            title: "点击保存"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Check)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          _createVNode(_component_el_icon, {
                                            onClick: ($event: any) => (_ctx.onDeleteTemplate(scope.$index)),
                                            title: "点击删除",
                                            style: {"margin-left":"5px"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Delete)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onSelectionChange", "data"])
                          ]),
                          _: 1
                        }),
                        (_ctx.OrderManagement_Order_Summary_BillingInformation_ViewAccountsPayable == true)
                          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                              key: 0,
                              label: "从应付账单导入",
                              name: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_table, {
                                  onSelectionChange: _ctx.handleSelectionChange,
                                  "tree-props": { children: 'Child', hasChildren: 'hasChildren' },
                                  "row-key": "Id",
                                  "default-expand-all": false,
                                  data: _ctx.paymentBill.Items,
                                  ref: "$templateCollectionTableFromPayment",
                                  style: {"width":"100%","margin-top":"15px"},
                                  "header-cell-style": { 'text-align': 'left' },
                                  "cell-style": { 'text-align': 'left' },
                                  border: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_table_column, {
                                      type: "selection",
                                      width: "55",
                                      selectable: _ctx.selectablePayment
                                    }, null, 8, ["selectable"]),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.Pool",
                                      label: "Booking No",
                                      width: "150px",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        (scope.row.Pool)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_190, _toDisplayString(_ctx.isString(scope.row.Pool.BookingNo, scope.row)), 1))
                                          : (scope.row.Child == null || scope.row.Child == undefined || scope.row.Child.length <= 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_191, " 未分摊 "))
                                            : (_openBlock(), _createElementBlock("span", {
                                                key: 2,
                                                style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","color":"#fe995b","cursor":"pointer"},
                                                onClick: ($event: any) => (_ctx.onTemplateChild(scope.row))
                                              }, [
                                                (scope.row.IsOpen == false)
                                                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_Plus)
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_Minus)
                                                      ]),
                                                      _: 1
                                                    })),
                                                _hoisted_193
                                              ], 8, _hoisted_192))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.SupplierLabel",
                                      label: "供应商",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        (scope.row.FromId == null || scope.row.FromId == undefined)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_194, _toDisplayString(_ctx.isString(scope.row.SupplierLabel)), 1))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_195, "—"))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.CostId",
                                      label: "费用名称",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        (scope.row.FromId == null || scope.row.FromId == undefined)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_196, _toDisplayString(_ctx.isString(scope.row.CostName)), 1))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_197, _toDisplayString(_ctx.isString(scope.row.Cost.NameZh, scope.row)) + "分摊 ", 1))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.CurrencySystem",
                                      label: "币制",
                                      width: "60px",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        (scope.row.FromId == null || scope.row.FromId == undefined)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                                              (scope.row.CurrencySystem)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    style: {"width":"100%","word-break":"break-all","text-align":"left"},
                                                    title: scope.row.CurrencySystem.FullName
                                                  }, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code)), 9, _hoisted_199))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_200, " 暂无数据 "))
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_201, [
                                              (scope.row.CurrencySystem)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_202, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code, scope.row)), 1))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_203, [
                                                    (scope.row.FromId != undefined)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_204, "—"))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_205, "暂无数据"))
                                                  ]))
                                            ]))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.UnitPrice",
                                      label: "单价",
                                      width: "100px",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("div", _hoisted_206, _toDisplayString(_ctx.isString(scope.row.UnitPrice, scope.row)), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.FirstChargeUnitId",
                                      label: "计价单位",
                                      width: "120px",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        (scope.row.FirstChargeUnit != null && scope.row.FirstChargeUnit != undefined)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_207, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnit.Code, scope.row)), 1))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_208, [
                                              (scope.row.FromId != undefined)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_209, "—"))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_210, "暂无数据"))
                                            ]))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.FirstChargeUnitNumber",
                                      label: "数量",
                                      width: "120px",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("div", _hoisted_211, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnitNumber, scope.row)), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.TotalPrice",
                                      label: "单项合计",
                                      width: "120px",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        (scope.row.FromId == null || scope.row.FromId == undefined)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_212, _toDisplayString(scope.row.TotalPrice), 1))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_213, _toDisplayString(_ctx.isString(scope.row.TotalPrice, scope.row)), 1))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.Remark",
                                      label: "备注",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("div", _hoisted_214, _toDisplayString(_ctx.isString(scope.row.Remark, scope.row)), 1)
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.billType != 30)
                                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                                          key: 0,
                                          prop: "scope.row.StartDateString",
                                          label: "记账起始时间",
                                          width: "140px",
                                          "show-overflow-tooltip": true
                                        }, {
                                          default: _withCtx((scope) => [
                                            (scope.row.FromId == null || scope.row.FromId == undefined)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_215, _toDisplayString(_ctx.isString(scope.row.StartDateString)), 1))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_216, "—"))
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_el_table_column, {
                                      prop: "scope.row.AccountPeriod",
                                      label: "账期（天数）",
                                      width: "130px",
                                      "show-overflow-tooltip": true
                                    }, {
                                      default: _withCtx((scope) => [
                                        (scope.row.FromId == null || scope.row.FromId == undefined)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_217, _toDisplayString(_ctx.isString(scope.row.AccountPeriod)), 1))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_218, "—"))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onSelectionChange", "data"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onTabClick"])
                  ])),
            _createElementVNode("div", _hoisted_219, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.importBottomButtons,
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.importBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickImport
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "style"]))
      : _createCommentVNode("", true),
    (_ctx.saveRuleForm.Data != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 4,
          modelValue: _ctx.saveRuleForm.Data.Visiable,
          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.saveRuleForm.Data.Visiable) = $event)),
          "show-close": false,
          style: {"width":"30%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_220,
            _createElementVNode("div", _hoisted_221, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_miezz_form, {
              ref: "$saveRuleForm",
              modelValue: _ctx.saveRuleForm,
              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.saveRuleForm) = $event)),
              fix: true
            }, {
              "form-item": _withCtx(({ item }) => [
                (item.Prop == 'IsSave')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        (item.Prop == 'IsSave')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_222, [
                              (_ctx.saveRuleForm.Data.IsSave == true)
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    label: "",
                                    width: "0px"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_223
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.saveRuleForm.Data.IsSave == false)
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 1,
                                    label: "模板名称",
                                    "label-width": "100px",
                                    prop: "Name",
                                    rules: [
                                    {
                                        required: true,
                                        message: '信息不能为空',
                                        trigger: 'change',
                                    },
                                ]
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        style: {"width":"100% !important"},
                                        modelValue: _ctx.saveRuleForm.Data.Name,
                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.saveRuleForm.Data.Name) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_224,
            _createVNode(_component_miezz_button_bar, {
              modelValue: _ctx.saveBottomButtons,
              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.saveBottomButtons) = $event)),
              isBackground: true,
              onHandleClick: _ctx.handleClickSave
            }, null, 8, ["modelValue", "onHandleClick"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.poolRuleForm.Data != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 5,
          modelValue: _ctx.poolRuleForm.Data.Visiable,
          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.poolRuleForm.Data.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_225,
            _createElementVNode("div", _hoisted_226, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.billType == 20 && _ctx.pools.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_227, "不选择Booking No代表该费用属于整票订单 "))
              : _createCommentVNode("", true),
            _createVNode(_component_miezz_form, {
              ref: "$poolRuleForm",
              modelValue: _ctx.poolRuleForm,
              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.poolRuleForm) = $event)),
              fix: true
            }, {
              "form-item": _withCtx(({ item }) => [
                (item.Prop == 'PoolId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        (item.Prop == 'PoolId')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_228, [
                              _createVNode(_component_el_form_item, {
                                label: "Booking No",
                                prop: "PoolId",
                                rules: (_ctx.billType != 20) ? [{ required: true, message: '信息不能为空', trigger: 'blur', },] : null
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    clearable: true,
                                    modelValue: _ctx.poolRuleForm.Data.PoolId,
                                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.poolRuleForm.Data.PoolId) = $event)),
                                    filterable: "",
                                    placeholder: "请选择",
                                    onChange: _ctx.onChangePoolId,
                                    disabled: (_ctx.billType == 20 && _ctx.pools.length == 1) ? true : false
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pools, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.Value,
                                          label: item.Label,
                                          disabled: item.Data.IsSave,
                                          value: item.Value
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", {
                                              title: item.Data.IsSave == true ? '该委托书已被锁定' : ''
                                            }, [
                                              (item.Data.IsSave == true)
                                                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Lock)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true),
                                              _createTextVNode(_toDisplayString(item.Label), 1)
                                            ], 8, _hoisted_229)
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "disabled", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onChange", "disabled"])
                                ]),
                                _: 2
                              }, 1032, ["rules"]),
                              (_ctx.isImport != true)
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    label: "账单行数",
                                    prop: "Number",
                                    rules: [{ required: true, message: '信息不能为空', trigger: 'blur', },]
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.poolRuleForm.Data.Number,
                                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.poolRuleForm.Data.Number) = $event)),
                                        onChange: _cache[42] || (_cache[42] = ($event: any) => (_ctx.onChangeNumber()))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_230, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.poolBottomButtons,
                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.poolBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickPool
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.addPoolBillForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 6,
          modelValue: _ctx.addPoolBillForm.Visiable,
          "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.addPoolBillForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_231,
            _createElementVNode("div", _hoisted_232, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_form, {
                ref: "refaddPoolBillForm",
                model: _ctx.addPoolBillForm
              }, {
                default: _withCtx(() => [
                  (_ctx.billType == 10 || _ctx.billType == 20)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "对账对象",
                        prop: "SelectId",
                        rules: [{ required: true, message: '信息不能为空', trigger: 'blur', },]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_autocomplete, {
                            modelValue: _ctx.addPoolBillForm.SelectLabel,
                            "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.addPoolBillForm.SelectLabel) = $event)),
                            clearable: true,
                            "fetch-suggestions": _ctx.querySearchClientCompanyForPoolBill,
                            "popper-class": "my-autocomplete",
                            placeholder: "请填写关键词",
                            onChange: _cache[47] || (_cache[47] = ($event: any) => (_ctx.onChangeClientCompanyIdForPoolBill())),
                            onClear: _cache[48] || (_cache[48] = ($event: any) => (_ctx.onChangeClientCompanyIdForPoolBill())),
                            onSelect: _cache[49] || (_cache[49] = ((item) => { _ctx.handleSelectClientCompanyForPoolBill(item) }))
                          }, {
                            default: _withCtx(({ item }) => [
                              _createElementVNode("span", _hoisted_233, _toDisplayString(item.Label), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "fetch-suggestions"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isImport != true)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: "账单行数",
                        prop: "Number",
                        rules: [{ required: true, message: '信息不能为空', trigger: 'blur', },]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.addPoolBillForm.Number,
                            "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.addPoolBillForm.Number) = $event)),
                            onChange: _cache[51] || (_cache[51] = ($event: any) => (_ctx.onChangePoolBillNumber()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _createElementVNode("div", _hoisted_234, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.poolBillBottomButtons,
                "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.poolBillBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickPoolBill
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.companyForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 7,
          modelValue: _ctx.companyForm.Visiable,
          "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.companyForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_235,
            _createElementVNode("div", _hoisted_236, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: _ctx.companyForm.Title,
                  "label-width": "100px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.companyForm.SelectId,
                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.companyForm.SelectId) = $event)),
                      filterable: "",
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companys, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.Value,
                            label: item.Label,
                            value: item.Value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_237, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.companyBottomButtons,
                "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.companyBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickCompany
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_miezz_supplier, {
      ref: "Supplier",
      isDetail: false,
      onOnSelectSupplier: _ctx.onSelectSupplier
    }, null, 8, ["onOnSelectSupplier"])
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}